import { Button } from "@chakra-ui/react";
import React from "react";
import { H2Dashboard } from "components/text/headings";
import DataTableV2 from "../../../../components/DataTable/DateTableV2";
import { formatDate } from "../../../../utils";
import { ArrowUpRight } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../../config";

const CompletedAuditList = ({ auditList }) => {
  const navigate = useNavigate();

  const columns = [
    {
      header: "Stage",
      accessorKey: "stageName",
    },
    {
      header: "Start Date",
      accessorKey: "startDate",
      cell: ({ cell }) => formatDate(new Date(cell.getValue()), false, false),
    },
    {
      header: "End Date",
      accessorKey: "endDate",
      cell: ({ cell }) => formatDate(new Date(cell.getValue()), false, false),
    },
    {
      header: "Questions",
      accessorKey: "totalQuestions",
    },
    {
      header: "Auditors",
      accessorFn: (row) => row.auditors?.join(", ") || "-",
    },
    {
      header: "",
      id: "view",
      size: 80,
      cell: ({ row }) => (
        <Button
          size="xs"
          variant="ghost"
          color="gray.500"
          _hover={{ color: "darkTeal" }}
          rightIcon={<ArrowUpRight size={14} />}
          onClick={() => navigate(`${routes.issbCompletedAudit}?id=${row.original.id}`)}
        >
          View
        </Button>
      ),
    },
  ];

  return (
    <>
      <H2Dashboard>Completed Audits</H2Dashboard>
      <DataTableV2
        data={auditList}
        columns={columns}
        serverSidePagination={false}
        showPaginator={false}
        onRowClick={(event, row) => navigate(`${routes.issbCompletedAudit}?id=${row.original.id}`)}
      />
    </>
  );
};

export default CompletedAuditList;
